export default `
mutation SendReportEmails($sendReportEmailsInput: SendReportEmailsInput!) {
  sendReportEmails(sendReportEmailsInput: $sendReportEmailsInput) {
    url
  }
}
`;
